import type { AfterResponseHook } from "ky";

export const envelopeHook: AfterResponseHook = ({ response }) =>
  response.ok
    ? response
        .clone() // Response body is a one-time stream; clone preserves the original for ky's internal handling
        .json()
        .then(
          (raw) =>
            new Response(JSON.stringify((raw as { data: unknown }).data), {
              headers: response.headers,
              status: response.status,
            }),
        )
    : undefined;
